import { cn } from '@altify/components';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { CustomLoader } from 'components/CustomLoader/CustomLoader';
import { SEO } from 'components/Seo/Seo';
import { AnimatePresence, motion } from 'motion/react';
import { useSelector } from 'react-redux';
import { RootState } from 'store/reducer';
import messages from './seoMessages';

// TODO: Add some code in the beforeLoad to load the current registration state and redirect the user to the correct step
export const Route = createFileRoute('/auth/signup')({
  component: RegisterView,
});

function RegisterView() {
  const { language } = useSelector(
    (rootState: RootState) => rootState.language,
  );

  const seoMessages = messages[language];
  const stepNumber: number = 0;
  const loading = false;

  return (
    <>
      <SEO
        title={seoMessages.title}
        description={seoMessages.description}
        keywords={seoMessages.keywords}
        page="register"
      />
      <div className="relative">
        {!loading ? null : <CustomLoader page />}
        <div
          className={`max-w-7xl mx-auto sm:px-6 lg:px-8 -mt-4 sm:mt-0  ${
            loading ? `h-full` : null
          }`}>
          <div className={`max-w-3xl mx-auto ${loading ? `h-full` : null}`}>
            <div
              className={`flex flex-col justify-center lg:px-8 sm:px-6 sm:py-12 ${
                loading ? `h-10/12` : null
              }`}>
              {!loading && (
                <div className="border-gray-200 ">
                  <nav className="-mb-px flex">
                    {buildProgressBar(stepNumber)}
                  </nav>
                </div>
              )}

              {loading ? (
                <CustomLoader page />
              ) : (
                <AnimatePresence>
                  <motion.div
                    initial={{ x: 100, opacity: 0 }}
                    exit={{ x: -100, opacity: 0 }}
                    animate={{ x: 0, opacity: 1 }}
                    className={cn(
                      stepNumber !== 6 ? 'bg-ghost-white' : 'bg-background',
                    )}>
                    <Outlet />
                  </motion.div>
                </AnimatePresence>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

function buildProgressBar(stepNumber: number) {
  const results = [];
  if (!stepNumber) return null;

  const numberOfRegistrationSteps = 7;

  for (let i = 0; i < numberOfRegistrationSteps; i++)
    if (i < stepNumber)
      results.push(
        <div
          key={'step-' + i}
          className="w-1/4 border-b-4 border-primary-button rounded-b-none">
          &nbsp;
        </div>,
      );
    else
      results.push(
        <div
          key={'step-' + i}
          className="w-1/4 border-b-4 border-transparent rounded-b-none">
          &nbsp;
        </div>,
      );

  return results;
}
